/**
 * WeightInputCell - 权重输入组件
 */
import React from 'react';
import { InputNumber } from 'antd';

interface WeightInputCellProps {
    deptId: number;
    weightField: string;
    value: number | undefined;
    onChange: (deptId: number, field: string, value: any) => void;
}

export const WeightInputCell: React.FC<WeightInputCellProps> = ({
    deptId, weightField, value, onChange
}) => {
    // 针对 attitude_weight，如果没有值，显示默认 15
    const displayValue = (weightField === 'attitude_weight' && value === undefined) ? 15 : value;

    return (
        <InputNumber
            style={{ width: 100 }}
            min={0}
            max={100}
            value={displayValue}
            onChange={v => onChange(deptId, weightField, v)}
            size="small"
            formatter={val => val ? `${val}%` : ''}
            parser={val => parseFloat(val!.replace('%', '')) || 0}
            placeholder="权重"
        />
    );
};
